// @unocss-include
'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'clsx';
import { useRef } from 'react';
import { useBoundsCssVars } from '../../hooks.js';
import { BoxContext } from '../box/Box.js';
import { HideWhileKeyboardOpen } from '../utility/HideWhileKeyboardOpen.js';
export function PageNav(_a) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    const bodyRef = useRef(document.documentElement);
    const ref = useBoundsCssVars(undefined, bodyRef, {
        left: '--nav-left',
        top: '--nav-top',
        width: '--nav-width',
        height: '--nav-height',
        ready: '--nav-ready',
    });
    return (_jsx(HideWhileKeyboardOpen, Object.assign({}, props, { className: classNames('layer-components:[grid-area:nav] layer-components:relative layer-components:z-nav layer-components:pb-[calc(0.25rem+env(safe-area-inset-bottom,0px))]', 'layer-components:before:content-[""] layer-components:before:absolute layer-components:before:inset-x-4 layer-components:before:top-0 layer-components:before:h-px layer-components:before:bg-dark-blend', 'layer-components:md:[grid-area:nav] layer-components:md:sticky layer-components:md:top-0 layer-components:md:h-auto layer-components:md:bottom-auto layer-components:md:left-auto layer-components:md:right-auto layer-components:md:before:hidden', className), ref: ref, children: _jsx(BoxContext.Provider, { value: { spacingScale: 1 }, children: children }) })));
}
//# sourceMappingURL=PageNav.js.map